import {
  BlacklistType,
  FinCEN314aEntityFilterItem,
  FinCEN314aEntityFilterOperator,
} from 'app/modules/lists/models';
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';

export const MATCHLIST_TYPE_LABELS: Record<BlacklistType, string> = {
  STRING: 'String',
  IP_INET: 'INET',
  IP_CIDR: 'CIDR',
  USER: 'User',
  BUSINESS: 'Business',
};

export const BLACKLIST_TYPE_OPTIONS: U21SelectOptionProps<BlacklistType>[] = [
  {
    text: MATCHLIST_TYPE_LABELS.STRING,
    value: 'STRING',
  },
  {
    text: MATCHLIST_TYPE_LABELS.IP_INET,
    value: 'IP_INET',
  },
  {
    text: MATCHLIST_TYPE_LABELS.IP_CIDR,
    value: 'IP_CIDR',
  },
  {
    text: MATCHLIST_TYPE_LABELS.USER,
    value: 'USER',
  },
  {
    text: MATCHLIST_TYPE_LABELS.BUSINESS,
    value: 'BUSINESS',
  },
];

// FinCEN 314(a) constants

export const ENTITY_FILTER_OPERATOR_OPTIONS: U21SelectOptionProps<FinCEN314aEntityFilterOperator>[] =
  [
    { text: 'is', value: 'is' },
    { text: 'is not', value: 'is_not' },
  ];

export const EMPTY_FILTER: FinCEN314aEntityFilterItem = {
  field: undefined,
  operator: 'is',
  value: '',
};

export const MIN_FUZZY_MATCH_THRESHOLD = 0.8;

export const DEFAULT_PERSON_FULL_NAME_MATCH_THRESHOLD = 0.85;
export const DEFAULT_PERSON_ADDRESS_MATCH_THRESHOLD = 0.82;

export const DEFAULT_BUSINESS_NAME_MATCH_THRESHOLD = 0.85;
export const DEFAULT_BUSINESS_ADDRESS_MATCH_THRESHOLD = 0.8;
